import React from 'react';

class LogoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logoutURL: process.env.REACT_APP_LOGOUT_REDIRECT_URL, // 登出網址，預設為 eService 首頁
      logoutFormActionUrl: process.env.REACT_APP_LOGOUT_FORM_ACTION,
    };
  }

  render() {
    return (
      <React.Fragment>
        <form id='LogoutForm' name='LogoutForm' method='post' action={this.state.logoutFormActionUrl}>
          <input type='hidden' value={this.state.logoutURL} name='url' id='logoutURL' />
        </form>
      </React.Fragment>
    );
  }
}

export default LogoutForm;
